<template>
  <div class="registration-page">
    <section class="registration-header">
      <h1 class="page-heading">Register for Resumes and Reels</h1>
      <p class="page-intro">
        This year we are offering a chance to get your work and resume critiqued
        by an industry professional who will give you direct feedback on how to
        positively solidify your body of work!
      </p>
      <div class="text-center">
        <v-btn
          @click="openRegistrationDialog"
          color="white"
          class="share-memory-btn v-btn--emphasis"
          >Register Now</v-btn
        >
        <v-dialog
          persistent
          max-width="990"
          v-if="registrationDialog"
          v-model="registrationDialog"
        >
          <v-card>
            <RegistrationForm @close="registrationDialog = false"/>
          </v-card>
        </v-dialog>
      </div>
    </section>
  </div>
</template>

<script>
import formMixin from "@/mixins/form.mixin";

export default {
  name: "RegistrationPage",
  metaInfo: {
    titleTemplate: "%s - Registration"
  },
  extends: formMixin,
  data() {
    return {
      registrationDialog: false,
      loading: false
    };
  },
  methods: {
    openRegistrationDialog() {
      this.registrationDialog = true;
    }
  }
};
</script>

<style scoped lang="scss">
.registration-page {
  color: $cmf-darkgrey;
}
.registration-header {
  padding: 80px 40px;
  text-align: center;
}
</style>
